/**
 * create-shared-list-modal.component.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

import { DialogRef, ModalComponent } from "angular2-modal";
import { BSModalContext } from "angular2-modal/plugins/bootstrap";
import { WatchlistService } from "./watchlist.service";
import { UserService } from "app/auth/identity/user.service";
import { Group } from "app/auth/identity/group";

// import { WatchlistService } from "./watchlist.service";

export interface CreateSharedListModalContext extends BSModalContext
{
	groupId: number;
	forEdit?: boolean;
	initialValues?: {
		title: string;
		description: string;
		stableUrl: string;
	}
}

export interface SharedListModalResult
{
	groupId: number;
	title: string;
	description: string;
	stableUrl?: string;
}

@Component({
	template: `
<div class="modal-header">
	<button
		type="button"
		class="close"
		(click)="dialog.dismiss()"
		aria-label="Close">
		<span aria-hidden="true">&times;</span>
	</button>
	<h4 class="modal-title">
		{{forEdit ? 'Edit' : 'Create'}} Shared Work List
	</h4>
</div>
<div class="modal-body">
	<p *ngIf="!forEdit">
		Creating within security group: 
		<span class="badge" style="vertical-align: baseline">
			{{ group.name }} (#{{group.id}})
		</span>
	</p>
	<div class="form-group">
		<label>Title</label>
		<input
			type="text"
			class="form-control"
			placeholder="A short name to identify the list"
			[formControl]="title">
	</div>
	<div class="form-group">
		<label>Description</label>
		<textarea
			class="form-control"
			[formControl]="description"
			placeholder="A longer explanation of the list's purpose...">
		</textarea>
	</div>
	<div class="form-group">
		<label>Stable URL <em>[optional]</em></label>
		<input
			type="text"
			class="form-control"
			placeholder="/my-path"
			[formControl]="stableUrl">
	</div>
	<p *ngIf="errorMessage" class="text-danger">{{errorMessage}}</p>
</div>
<div class="modal-footer">
	<button
		type="button"
		class="btn btn-primary"
		(click)="add()">
		{{forEdit ? 'Save' : 'Create'}}
	</button>
	<button
		type="button"
		class="btn btn-default"
		(click)="dialog.dismiss()">
		Cancel
	</button>
</div>

  `
})
export class CreateSharedListModalComponent
	implements ModalComponent<CreateSharedListModalContext>
{
	public forEdit : boolean = false;

	/**
	 * String container for validation errors to be displayed.
	 */
	public errorMessage : string;

	/**
	 * The target group for the new list, chosen by the group currently selected
	 * when the dialog was launched.
	 */
	public group : Group;

	/**
	 * The title for the new list.
	 */
	public title : FormControl = new FormControl("", Validators.required);

	/**
	 * The description for the new list.
	 */
	public description : FormControl = new FormControl("", Validators.required);

	/**
	 * The description for the new list.
	 */
	public stableUrl : FormControl = new FormControl({value: "", disabled: true});

	public form : FormGroup = new FormGroup({
		title: this.title,
		description: this.description,
		stableUrl: this.stableUrl
	});

	constructor (
		public dialog : DialogRef<CreateSharedListModalContext>,
		public user : UserService,
		public watchlists : WatchlistService
	)
	{
		this.group = this.user.self.groups.find(
			g => g.id == dialog.context.groupId);
		if (!this.group) {
			console.error(`Could not find group with id ${dialog.context.groupId}`);
			dialog.bailOut();
		}
		if (dialog.context.forEdit) {
			this.forEdit = true;
		}
		if (dialog.context.initialValues) {
			this.title.setValue(dialog.context.initialValues.title);
			this.description.setValue(dialog.context.initialValues.description);
			this.stableUrl.setValue(dialog.context.initialValues.stableUrl);
		}
	}

	/**
	* Create a new shared list by returning the form values to the outer handler.
	*/
	public add () : void
	{
		const result : SharedListModalResult = {
			...this.form.value,
			groupId: this.group.id
		};
		this.dialog.close(result);
	}
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/watchlist/create-shared-list-modal.component.ts